export const PRODUCT_CONDITIONS = [
  'Used',
  'Used - Like New',
  'Refurbished',
  'New'
];

export const DEFAULT_PRODUCT_CONDITION = 'New';
